var LZD = window.LZD || {};
LZD.experiments = {};
LZD.venture = "vn"; // Possible values: my, vn, sg, ph, th, id
LZD.lang = "vi";
LZD.translation = LZD.translation || {};
LZD.translation['in'] = 'trong';
LZD.suggestApiUrl = "";
LZD.csrfToken = {
    name: "FORM_TOKEN",
    value: "1cb6b5f7e58bce9e76e556cbaaf7adc73d6a2b88"
};
var JS_ERRORS_DISABLE = 1;
// if (typeof console === "undefined" || typeof console.log === "undefined") {
//     console = {};
//     console.log = function() {};
// }

if (!route) {
    var route = "";
}